import { Card } from 'ui';
import type { TransactionResultParams } from 'features/transactions';
import type { GivingScopeEnum } from '..';
import { GivingTransactionResultModal } from '../../giving-transaction-result-modal';
import { Navigation } from '../navigation';
import { CreateGiveSteps } from './create-give-steps';

type P = {
  getPathToGivingDetail: (id: string) => string;
  giveTransaction: TransactionResultParams;
  navigateToGiveNow: () => Promise<void>;
  navigateToGivingBrowse: () => Promise<void>;
  paymentRedirectUrl: string;
  scope: GivingScopeEnum;
};

const GiveNow = ({
  getPathToGivingDetail,
  giveTransaction,
  navigateToGiveNow,
  navigateToGivingBrowse,
  paymentRedirectUrl,
  scope,
}: P) => (
  <>
    <Navigation navigateToGiveNow={navigateToGiveNow} navigateToGivingBrowse={navigateToGivingBrowse} scope={scope} />
    <Card>
      <CreateGiveSteps getPathToGivingDetail={getPathToGivingDetail} paymentRedirectUrl={paymentRedirectUrl} />
    </Card>
    <GivingTransactionResultModal
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      isOpened={Boolean(giveTransaction?.transactionResult)}
      onClose={() => {
        giveTransaction.onModalClose();
      }}
      result={giveTransaction.transactionResult}
    />
  </>
);

export default GiveNow;
